import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from './store'
import "./styles/index.scss";
import { IsPC } from "./utils/index";
import EasySlider from "vue-easy-slider";

Vue.use(EasySlider);

Vue.prototype.$isPc = IsPC;
Vue.prototype.initCanvas = function (id) {
  let scale = 1;
  this.w = IsPC() ? document.body.offsetWidth : document.body.offsetHeight;
  this.h = !IsPC() ? document.body.offsetWidth : document.body.offsetHeight;
  this.can = document.getElementById(id);
  this.ctx = this.can.getContext("2d");
  // var scale = window.devicePixelRatio; // Change to 1 on retina screens to see blurry canvas.
  if (window.devicePixelRatio) {
    scale = window.devicePixelRatio;
  }
  console.log(window.devicePixelRatio, " window.devicePixelRatio");
  this.can.style.width = this.w + "px";
  this.can.style.height = this.h + "px";
  this.can.width = Math.floor(this.w * scale);
  this.can.height = Math.floor(this.h * scale);
  // this.can.width = this.w;
  // this.can.height = this.h;
};

Vue.config.productionTip = false;

Vue.directive('dragscroll', function (el) {
  if (IsPC()) {
    el.onmousedown = function (ev) {
      window.clearTimer()
      const disX = ev.clientX
      const disY = ev.clientY
      const originalScrollLeft = el.scrollLeft
      const originalScrollTop = el.scrollTop
      const originalScrollBehavior = el.style['scroll-behavior']
      const originalPointerEvents = el.style['pointer-events']
      el.style['scroll-behavior'] = 'auto'
      // 鼠标移动事件是监听的整个document，这样可以使鼠标能够在元素外部移动的时候也能实现拖动
      document.onmousemove = function (ev) {
        ev.preventDefault()
        const distanceX = ev.clientX - disX
        const distanceY = ev.clientY - disY
        el.scrollTo(originalScrollLeft - distanceX, originalScrollTop - distanceY)
        // 由于我们的图片本身有点击效果，所以需要在鼠标拖动的时候将点击事件屏蔽掉
        el.style['pointer-events'] = 'none'
      }
      document.onmouseup = function () {
        document.onmousemove = null
        document.onmouseup = null
        el.style['scroll-behavior'] = originalScrollBehavior
        el.style['pointer-events'] = originalPointerEvents
      }
    }    
  }
})

new Vue({
  store,
  router,
  render: (h) => h(App),
}).$mount("#app");
